import { Directive, ElementRef, Input } from '@angular/core';
import { AuthService } from './services/auth.service';

@Directive({
  selector: '[checkPerms]'
})

export class AuthDirective {

  constructor(
    private elementRef: ElementRef,
    private authService: AuthService
  ) { }

  @Input() set checkPerms(url: string) {
    if (!this.authService.hasPerms(url)) {
      this.elementRef.nativeElement.style.display = 'none';
    }
  }
}
